import React from "react";
import PropTypes from "prop-types";
import "components/InputBar/InputBar.css";
import { getInputFieldNameValue } from "utils/commonMethods";

//Input bar to let user input any text
function InputBar({
  type = "text",
  onChange,
  className: customClassName = "",
  inputProps = {},
  PlaceholderIcon = null,
  name = "",
  value,
  children,
}) {
  //Manipulates/filters the data
  const onChangeMiddleware = function (ev) {
    let { name, value } = getInputFieldNameValue(ev);
    return onChange(name, value);
  };

  let customInputClassName = "input-bar";

  //If input type is search, add search icon into it using search-input class.
  if (type === "search") {
    customInputClassName += " search-input ";
  }

  //Concatenate placeholder icon class if any icon needs to be shown.
  if (PlaceholderIcon) {
    customInputClassName += " input-bar--placeholder-icon-enabled";
  }

  return (
      <div className={"input-bar__wrapper " + customClassName}>
      {PlaceholderIcon && (
        <div className="input-bar__placeholder-icon">
          <PlaceholderIcon />
        </div>
      )}
      <input
        value={value}
        className={customInputClassName}
        type={type}
        onChange={onChangeMiddleware}
        name={name}
        {...inputProps}
      />
      {children}
    </div>
  );
}

InputBar.propTypes = {
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  PlaceholderIcon: PropTypes.object,
  name: PropTypes.string,
  value: PropTypes.any,
};

export default InputBar;
